import light from './light';
import dark from './dark';
import primary from './primary';
import secondary from './secondary';

export default {
  light,
  dark,
  primary,
  secondary,
};
